
import HomePage from '../pages/home.f7.html';
import AboutPage from '../pages/about.f7.html';
import FormPage from '../pages/form.f7.html';
import CatalogPage from '../pages/catalog.f7.html';
import ProductPage from '../pages/product.f7.html';
import SettingsPage from '../pages/settings.f7.html';
import Pass from '../pages/pass.f7.html';
import News from '../pages/news.f7.html';
import Account from '../pages/account.f7.html';
import History from '../pages/history.f7.html';
import HistoryV2 from '../pages/historyV2.f7.html';
import Financial from '../pages/financial.f7.html';
import FinancialV2 from '../pages/financialV2.f7.html';
import Plan from '../pages/plan.f7.html';
import StockBuy from '../pages/stockbuy.f7.html';
import StockSell from '../pages/stocksell.f7.html';
import Transaction from '../pages/transaction.f7.html';

import DynamicRoutePage from '../pages/dynamic-route.f7.html';
import RequestAndLoad from '../pages/request-and-load.f7.html';
import NotFoundPage from '../pages/404.f7.html';

var routes = [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/about/',
    component: AboutPage,
  },
  {
    path: '/form/',
    component: FormPage,
  },
  {
    path: '/catalog/',
    component: CatalogPage,
  },
  {
    path: '/product/:id/',
    component: ProductPage,
  },
  {
    path: '/settings/',
    component: SettingsPage,
  },
  {
    path: '/pass/',
    component: Pass,
  },
  {
    path: '/news/',
    component: News,
  },
  {
    path: '/financial/',
    component: Financial,
  },
  {
    path: '/financialV2/',
    component: FinancialV2,
  },
  {
    path: '/account/',
    component: Account,
  },
  {
    path: '/history/',
    component: History,
  },
  {
    path: '/historyV2/',
    component: HistoryV2,
  },
  {
    path: '/plan/',
    component: Plan,
  },
  {
    path: '/stockbuy/',
    component: StockBuy,
  },
  {
    path: '/stocksell/',
    component: StockSell,
  },
  {
    path: '/transaction/',
    component: Transaction,
  },

  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function ({ router, to, resolve }) {
      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = to.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            props: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;